import { useTranslation } from 'react-i18next'

/**
 * Fatal, localized full-screen error shown when an embedded session's
 * `SessionContext.capabilities.features` doesn't include `protocol:1`.
 * The designer never mounts routes/state in this case — the embedding
 * host is on an incompatible protocol version and must be upgraded.
 */
export function EmbedError() {
  const { t } = useTranslation()
  return (
    <div
      data-testid="embed-error-screen"
      role="alert"
      className="flex h-screen w-screen flex-col items-center justify-center gap-3 bg-stone-50 p-8 text-center dark:bg-stone-950"
    >
      <h1 className="text-lg font-semibold text-stone-800 dark:text-stone-200">
        {t('embedError.title')}
      </h1>
      <p className="max-w-md text-sm text-stone-600 dark:text-stone-400">
        {t('embedError.body')}
      </p>
    </div>
  )
}
